// Every Moment Section

document.addEventListener("DOMContentLoaded",function(){

      const section=document.querySelector(".every-moment-section");

      if(!section) return;

      const cards=section.querySelectorAll(".moment-card");

      const observer=new IntersectionObserver(function(entries){

          entries.forEach(function(entry){

              if(entry.isIntersecting){

                  cards.forEach(function(card,index){

                      setTimeout(function(){

                          card.classList.add("show");

                      },index*300);

                  });

                  observer.disconnect();

              }

          });

      },{

          threshold:0.25

      });

      observer.observe(section);

});




document.addEventListener('DOMContentLoaded', function () {

    if (window.innerWidth > 767) return;

    setTimeout(function () {

        $('.every-moment-slider .slider-wrapper')
            .not('.slick-initialized')
            .slick({

                infinite: true,
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 3000,
                speed: 700,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '20%'

            });

    }, 100);

});
 
// Newly added
document.addEventListener('DOMContentLoaded', () => {
  const decorations = document.querySelectorAll('.fruit-bar-decoration, .left-fruit-bar-decoration');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
        observer.unobserve(entry.target); // Run only once
      }
    });
  }, {
    threshold: 0.3
  });

  decorations.forEach((item) => observer.observe(item));
});
 